<template>
  <div class="mb-5">
    <h2 class="mb-4">More About Our Model</h2>
    <button-toggle
      style="display: block; margin: 20px 0;"
      :items="[
        { value: 'raceDetails', text: 'Race Details' },
        { value: 'modelNotes', text: 'Model Notes' },
        { value: 'polls', text: 'Polls' },
        { value: 'fec', text: 'FEC' },
        { value: 'featureImportance', text: 'Feature Importance' },
        { value: 'pastElections', text: 'Past Elections' }
      ]"
      :selected="tab"
      @click="tab = $event">
    </button-toggle>
    <skeleton-loader :loading="loading" type="sentences">
      <template v-if="currentModel">
        <race-details v-if="tab === 'raceDetails'" :chamber="chamber" :election="election"></race-details>
        <model-notes v-if="tab === 'modelNotes'" :currentModel="currentModel" :models="models" :currentDate="currentDate" :chamber="chamber"></model-notes>
        <polls v-if="tab === 'polls'" :electionJson="election.electionJson"></polls>
        <fec v-if="tab === 'fec'" :electionJson="election.electionJson"></fec>
        <feature-importance v-if="tab === 'featureImportance'" :electionJson="election.electionJson"></feature-importance>
        <past-elections v-if="tab === 'pastElections'" :chamber="chamber" :electionJson="election.electionJson"></past-elections>
      </template>
    </skeleton-loader>

  </div>
</template>

<script>
import { ButtonToggle, SkeletonLoader } from '@/components/common'
import { FeatureImportance, Fec, ModelNotes, PastElections, Polls, RaceDetails } from './NoteTabs'

const props = {
  election: {
    required: true
  },
  chamber: {
    type: String,
    required: false
  },
  currentModel: {
    required: true
  },
  currentDate: {
    type: String,
    required: true
  },
  models: {
    type: Array,
    required: true
  },
  loading: {
     type: Boolean,
     required: true
  }
}

const components = {
  ButtonToggle,
  FeatureImportance,
  Fec,
  ModelNotes,
  PastElections,
  Polls,
  RaceDetails,
  SkeletonLoader
}

const computed = {
  electionJson () {
    return this.election.electionJson
  }
}

export default {
  props,
  components,
  computed,
  data: () => ({
    tab: 'raceDetails'
  })
}
</script>
